/**
 * AI 调用记录的数据请求（旧 composables/useLLMLogs.ts），接口与参数与旧版一致
 */
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { adminApi } from '@/api/admin'
import type { GlobalLLMLogsFilters, GlobalLLMLogsResult, UserLLMLogsResult } from './types'

const LLM_LOGS_KEY = ['admin', 'llm-logs'] as const

export function useUserLLMLogs(userId: number, page: number, pageSize: number) {
  return useQuery({
    queryKey: [...LLM_LOGS_KEY, 'user', userId, page, pageSize],
    queryFn: async (): Promise<UserLLMLogsResult> => {
      const response = await adminApi.getUserLLMLogs(userId, page, pageSize)
      return { user: response.data.user ?? null, logs: response.data.logs ?? [], total: response.data.total ?? 0 }
    },
    placeholderData: keepPreviousData
  })
}

export function useGlobalLLMLogs(page: number, pageSize: number, filters: GlobalLLMLogsFilters) {
  return useQuery({
    queryKey: [...LLM_LOGS_KEY, 'global', page, pageSize, filters],
    queryFn: async (): Promise<GlobalLLMLogsResult> => {
      const response = await adminApi.getAllLLMLogs({ page, page_size: pageSize, ...filters })
      return { logs: response.data.logs ?? [], total: response.data.total ?? 0 }
    },
    placeholderData: keepPreviousData
  })
}
